import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import Guide from './Guide';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const guide = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/guides/public/' + id,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateGuide = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.guide : null;
};

const getGuideSlug = (props: RouteComponentProps<any>) => {
  return props.match.params.name;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedGuide = getStateGuide(props);
    const state = guide(getGuideSlug(props), context);

    if (preloadedGuide) {
      return <Component guide={preloadedGuide} />;
    }

    if (state.error) {
      return <NotFound />;
    }

    if (state.loading || !state.data) {
      return <Loader />;
    }

    return <Component guide={state.data} />;
  };
}

export default withState(Guide);
